
import { NotificationSearch, NTNotification, NotificationService } from "@nt-portal/server-sdk";
import { BaseClientService } from "../base-client.service";
import { FetchParams } from "@nt-portal/common-sdk";


export class ClientNotificationService extends BaseClientService {

    private _service: NotificationService;


    constructor() {
        super();
        this._service = new NotificationService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }


    public async get(fetchParams: FetchParams, search: NotificationSearch) {
       console.log("Fetching notifications with search:", search);
        return await this._service.get(fetchParams, this.token, search);
    }

    // public async notify(type: string, payload: any) {
    //     return await this._service.notify(type, payload, this.token)
    // }

    public async getById(id: string) {
        return await this._service.getById(id, this.token);
    }

    public async update(item: NTNotification) {
        if (item.id)
            return await this._service.update(item, this.token);
    }

    public async markAsRead(ids: string[]) {
        return await this._service.markAsRead(ids, this.token)
    }


    public async count() {
        return await this._service.getCount(this.token)
    }

    public async delete(id: string) {
        return await this._service.delete(id, this.token);
    }
}


